import React from "react";
import { Chip } from "@mui/material";
import InfoCard from "../../../components/ui/InfoCard";
import { annualRevenueLabel, formatPhoneNumber } from "../../../utils/helpers";

const ParentCustomerInformation = ({
  customer,
  showServicedBy = false,
  showAnnualRevenue = false,
  tag = null,
}) => {
  if (!customer) return null;

  return (
    <InfoCard
      title="Company Info"
      badge={
        tag && <Chip label={tag} size="small" className="bg-[#F1EEFF] text-[#5B45CE] font-medium" />
      }
      items={[
        ["Name", customer?.clientName],
        ...(showServicedBy ? [["Company", customer?.company?.name]] : []),
        ["Email", customer?.email],
        ["Phone", formatPhoneNumber(customer?.phoneNumber)],
        ["Website", customer?.website],
        ...(showAnnualRevenue
          ? [["Annual Revenue", annualRevenueLabel(customer?.companyAnnualRevenue)]]
          : []),
        ["Address", customer?.address?.addressLine1],
        ["City", customer?.address?.city],
        ["State", customer?.address?.state],
        ["Zip / Post Code", customer?.address?.zipCode],
        ["Country", customer?.address?.country],
      ]}
    />
  );
};

export default ParentCustomerInformation;
